import React, { Component } from 'react'

export default class Item extends Component {
    product = this.props.products;
    render() {
      return (
          <div className='item'>
            <img className='item__img' alt={this.product.category} src={this.product.img} onClick={()=>this.props.onShowItem(this.product)}/>
            <h2 className='item__titl'>{this.product.title}</h2>
            <p className='item__desc'>{this.product.desc}</p>
            <div className='item__footer'>
                <p className='item__footer-price'>{this.product.price}</p>
                <div className='item__footer-add' onClick={ () => this.props.onAdd(this.product)}>+</div>
            </div>
          </div>
      )
    }
}
